import React, { useEffect, useState } from "react";
import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { NullableCheckbox, FreeResponseText } from "components";
import type { NullableCheckboxState } from "components/NullableCheckbox/types";
import { useAssessmentContext } from "hooks/assessment";
interface CheckboxProps {
  tags: string[]; // may be replaced with ID in future
  //id: string;
}

const Checkbox: React.FC<CheckboxProps> = ({ tags }) => {

  // get initial value from assessment context
  const { getValue, saveResponse } = useAssessmentContext();

  // set our checkbox state from our responses
  // set exactly once
  const [initState, setInitState] = useState<NullableCheckboxState>(null);

  const handleCheckboxChange = (tags: string[], checkboxValue: NullableCheckboxState) => {
    // Do NOT setInitState, as that will re-render the
    // NullableCheckbox Component
    //setInitState(checkboxValue);

    // if/when we change to relational db schema, call the api directly from here
    // to update the value
    saveResponse(tags, checkboxValue);
  };

  const getCachedValue = async (tags: string[]) => {
    // if/when we change to relational db schema, call the api directly from here
    // to retrieve the value stored in db
    return getValue(tags);
  };

  useEffect(() => {
    getCachedValue(tags)
      .then(initialValue => {
        setInitState(initialValue?.value);
      });
  }, []);

  return (
    <NullableCheckbox
      initialValue={initState}
      onChange={(checkboxValue: NullableCheckboxState) => handleCheckboxChange(tags, checkboxValue)} />
  );

};

export default Checkbox;
